<template>
  <div style="max-height: 350px;overflow-y: auto">
    <el-table
      :data="showTable"
      size="mini"
      border
      style="width: 100%"
      highlight-current-row
      ref="singleTable">
      <el-table-column
        type="index"
        label="序号"
        width="50"
        align="center">
      </el-table-column>
      <el-table-column
        prop="fm_name"
        label="电台名称"
        min-width="85"
        align="center">
      </el-table-column>
      <el-table-column
        prop="fm_frequency"
        label="电台频率"
        min-width="80"
        align="center">
      </el-table-column>
      <el-table-column
        prop="create_tm"
        label="创建时间"
        min-width="140"
        align="center">
      </el-table-column>
      <el-table-column align="center" label="操作" width="90">
        <template slot-scope="scope">
          <i title="刪除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delFmDid(scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCells">
      </el-pagination>
    </div>
    <el-dialog
      width="600px"
      :visible.sync="addEditShow"
      v-if="addEditShow"
      append-to-body
      center
      class="all-open">
      <div class="title-top-alarm">
        <div>
          <span>设置频率FM</span>
        </div>
        <div class="line-title"></div>
      </div>
      <add-edit-f-m :FMObj="FMObj" v-model="addEditShow" @getFather="getFather"></add-edit-f-m>
    </el-dialog>
</div>
</template>

<script>
import {querydevicefminfo, deletedevicefminfo} from '../../../api/device'
import addEditFM from '../childComponents/addEditFM'
export default {
  name: 'fmInfo',
  components: {addEditFM},
  props: {
    fmObj: {
      type: Object
    }
  },
  data () {
    return {
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      showTable: [],
      addEditShow: false,
      FMObj: {
        devicerow: '',
        fmRow: '',
        isAdd: true,
        orgRow: '',
        selectIds: []
      }
    }
  },
  created () {
    this.FMObj.devicerow = this.fmObj.deviceRow
    this.getFmInfo()
  },
  methods: {
    getFmInfo () {
      this.FMObj.selectIds = []
      let data = {
        did: this.fmObj.deviceRow.id,
        page: this.currentPage,
        size: this.pageSize
      }
      querydevicefminfo(data).then(res => {
        this.totalCells = res.data.cnt
        this.showTable = res.data.fminfo
        for (let i = 0; i < this.showTable.length; i++) {
          this.FMObj.selectIds.push(this.showTable[i].id)
        }
      }).catch(() => {})
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getFmInfo()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getFmInfo()
    },
    getOpenAdd () {
      this.addEditShow = true
    },
    getFather () {
      this.getFmInfo()
    },
    // 设备删除fm
    delFmDid (row) {
      let name = row.fm_name
      this.$confirm('此操作将永久删除该设备FM【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          did: this.fmObj.deviceRow.id,
          imei: this.fmObj.deviceRow.deviceid,
          fmid: row.id
        }
        deletedevicefminfo(data).then(() => {
          if (this.showTable.length === 1 && this.currentPage > 1) {
            this.currentPage -= 1
          }
          this.getFmInfo()
          this.$notify({
            title: '成功',
            message: '成功删除',
            type: 'success',
            duration: 2000
          })
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/fmInfo.vue